'use client';

import { jsxs, jsx } from "react/jsx-runtime";
import a__default, { useRef, useEffect } from "react";
import focusTrap from "../../../_virtual/index.js";
import { Button } from "../../atoms/Button/Button.js";
import { Text } from "../../atoms/Text/Text.js";
import { X } from "../../../react-icons.js";
import { KeyboardOnlyScrollable } from "../../quarks/KeyboardOnlyScrollable/KeyboardOnlyScrollable.js";
import { useId } from "../../utils/hooks/useId.js";
import { classNames } from "../../utils/styles/classNames.js";
import { CLOSE_BUTTON_LABEL } from "./utils/constants.js";
import { shouldOmitFooter } from "./utils/shouldOmitFooter.js";
import { Overlay } from "./Modal.Overlay.js";
import { Footer } from "./Modal.Footer.js";
import { defaultProps } from "./Modal.defaultProps.js";
import { bottomBorderRadius, contentSurface, content, base, header, title, wrapper } from "./Modal.css.js";
function Modal({
  a11yTitle,
  children,
  className,
  contentSurface: contentSurfaceProp,
  hiddenTitle,
  open,
  primaryAction,
  secondaryAction,
  title: title$1,
  onClose
}) {
  const contentSurface$1 = contentSurfaceProp || defaultProps.contentSurface;
  const initialFocusRef = a__default.useRef(null);
  const id = useId();
  const labelId = `chalk-modal-label-id-${id}`;
  const dialogRef = useRef(null);
  const contentClasses = classNames(
    content,
    contentSurface[contentSurface$1],
    shouldOmitFooter({ primaryAction, secondaryAction }) && bottomBorderRadius
  );
  useEffect(() => {
    var _a;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
      if (dialogRef.current) {
        focusTrap(event, dialogRef.current);
      }
    };
    if (open && window) {
      (_a = initialFocusRef.current) == null ? void 0 : _a.focus();
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      if (open && window) {
        window.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [open]);
  if (!open) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "aria-labelledby": labelId,
      "aria-modal": "true",
      className: classNames(className, wrapper),
      ref: dialogRef,
      role: "dialog",
      tabIndex: -1,
      children: [
        /* @__PURE__ */ jsx(Overlay, { onClick: onClose }),
        /* @__PURE__ */ jsxs("div", { className: base, children: [
          /* @__PURE__ */ jsxs("div", { className: header, children: [
            /* @__PURE__ */ jsxs("div", { className: title, children: [
              /* @__PURE__ */ jsx(
                Text,
                {
                  "aria-hidden": a11yTitle ? "true" : void 0,
                  as: a11yTitle ? "span" : "h2",
                  color: "onLight.text.primary",
                  id: labelId,
                  variant: "display.base",
                  visuallyHidden: hiddenTitle,
                  children: title$1
                }
              ),
              a11yTitle && /* @__PURE__ */ jsx(Text, { as: "h2", visuallyHidden: true, children: a11yTitle })
            ] }),
            /* @__PURE__ */ jsx(
              Button,
              {
                emphasis: "low",
                icon: X,
                ref: initialFocusRef,
                hiddenLabel: true,
                onClick: onClose,
                children: CLOSE_BUTTON_LABEL
              }
            )
          ] }),
          /* @__PURE__ */ jsx(KeyboardOnlyScrollable, { className: contentClasses, children }),
          /* @__PURE__ */ jsx(
            Footer,
            {
              primaryAction,
              secondaryAction
            }
          )
        ] })
      ]
    }
  );
}
export {
  Modal
};
